import script from "./FileUploadButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FileUploadButton.vue?vue&type=script&setup=true&lang=js"

import "./FileUploadButton.vue?vue&type=style&index=0&id=8ce32156&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ce32156"]])

export default __exports__